/**
 * DOM Elements References
 * Centralized DOM element queries
 */

export const elements = {
  // Search inputs
  zipInput: null,
  mobileZipInput: null,

  // Filters
  liveCheckbox: null,
  sportFilters: null,
  typeFilters: null,
  genderFilters: null,
  brandFilters: null,
  skillFilters: null,
  ageInput: null,
  sortSelect: null,
  typeFilterSelect: null,

  // Results
  resultsContainer: null,
  resultsHeading: null,
  resultsSubheading: null,
  resultsCount: null,
  activeFilters: null,
  pagination: null,
  noResults: null,

  // Banners
  fallbackBanner: null,
  fallbackTitle: null,
  fallbackText: null,

  // Sport items
  sportItems: [],

  // Filter panel
  filterPanel: null,
  mobileFilterToggle: null,
  closeFilters: null,
  saveFilters: null,
  resetFilters: null,
  resetFiltersDesktop: null,
  filtersCount: null,
  sidebarFiltersCounts: [],
};

/**
 * Initialize DOM element references
 */
export function initElements() {
  elements.zipInput = document.getElementById('zip-search');
  elements.mobileZipInput = document.getElementById('mobile-search-field');
  elements.liveCheckbox = document.getElementById('live-camps');
  elements.sportFilters = document.getElementById('sport-filters');
  elements.typeFilters = document.getElementById('type-filters');
  elements.genderFilters = document.getElementById('gender-filters');
  elements.brandFilters = document.getElementById('brand-filters');
  elements.skillFilters = document.getElementById('skill-filters');
  elements.ageInput = document.getElementById('age-input');
  elements.sortSelect = document.getElementById('camp-sort');
  elements.typeFilterSelect = document.getElementById('type-filter');
  elements.resultsContainer = document.getElementById('search-results');
  elements.resultsHeading = document.getElementById('results-heading');
  elements.resultsSubheading = document.getElementById('results-subheading');
  elements.resultsCount = document.getElementById('results-count');
  elements.activeFilters = document.getElementById('active-filters');
  elements.pagination = document.getElementById('pagination');
  elements.noResults = document.getElementById('no-results');
  elements.fallbackBanner = document.getElementById('fallback-banner');
  elements.fallbackTitle = document.getElementById('fallback-title');
  elements.fallbackText = document.getElementById('fallback-text');

  elements.sportItems = Array.from(
    document.querySelectorAll('.rd-search-modal__sport-item')
  ).map((item) => {
    return { slug: item.dataset.sportSlug, title: item.textContent };
  });

  elements.filterPanel = document.getElementById('filter-panel');
  elements.mobileFilterToggle = document.getElementById('mobile-filter-toggle');
  elements.closeFilters = document.getElementById('close-filters');
  elements.saveFilters = document.getElementById('save-filters');
  elements.resetFilters = document.getElementById('reset-filters');
  elements.resetFiltersDesktop = document.getElementById('reset-filters-desktop');
  elements.filtersCount = document.querySelector('.rd-search-results__show-filters-count');
  elements.sidebarFiltersCounts = Array.from(
    document.querySelectorAll('.rd-search-results__filters-count')
  );

  console.log('📍 DOM elements initialized');
}

/**
 * Get element by key
 * @param {string} key
 * @returns {HTMLElement|null}
 */
export function getElement(key) {
  return elements[key] || null;
}

console.log('📦 Elements module loaded');
